export const getters = {
  isAuthenticated(state) {
    if (!state.auth) {
      return false
    }
    return state.auth.loggedIn
  },

  loggedInUser(state) {
    return state.auth.user
  },

  menus(state) {
    if (state.auth && state.auth.user) {
      return state.auth.user.menus
    }
    return state.default_menus
  },

  userAuthors(state) {
    if (state.auth && state.auth.user) {
      return state.auth.user.authors
    }
    return state.default_authors
  },

  configs(state) {
    return state.configs
  },

  messages(state) {
    return state.messages
  },

  allLocales(state) {
    return state.locales
  }
}

export const state = () => ({
  init_locale: false,
  locales: [],
  locale: '',
  messages: {},
  reported_undefined_messages: {},
  full_loaded_locales: [],
  loading_locales: [],
  configs: undefined,
  default_menus: [],
  default_authors: [],
  default_menu_loaded: false
})

export const mutations = {
  INIT_LOCALE(state) {
    state.init_locale = true
  },
  SET_USER(state, user) {
    state.auth.user = user
  },
  FULL_LOADED_LOCALE(state, locale) {
    state.full_loaded_locales.push(locale)
  },
  SET_CONFIGS(state, configs) {
    state.configs = configs
  },
  SET_DEFAULT_MENUS(state, menus) {
    state.default_menus = menus
    state.default_menu_loaded = true
  },
  SET_DEFAULT_AUTHORS(state, authors) {
    state.default_authors = authors
  },
  SET_FAVORITE_LINKS(state, favoriteLinks) {
    state.auth.user.favoriteLinks = favoriteLinks
  },
  ADD_LOADING_LOCALE(state, locale) {
    state.loading_locales.push(locale)
  },
  SET_LOCALE(state, locale) {
    if (state.locales && state.locales.length > 0) {
      let found = false
      for (let i = 0; i < state.locales.length; i++) {
        if (state.locales[i].value === locale) {
          found = true
          break
        }
      }
      if (found) {
        localStorage.locale = locale
        state.locale = locale
      }
    }
  },
  REPORT_UNDEFINED_MESSAGE(state, { locale, key }) {
    if (
      state.reported_undefined_messages[locale] === undefined ||
      state.reported_undefined_messages[locale] === null
    ) {
      state.reported_undefined_messages[locale] = {}
    }
    state.reported_undefined_messages[locale][key] = true
  },
  SET_LOCALES(state, locales) {
    state.locales = locales
  },
  SET_MESSAGES(state, { locale, messages }) {
    state.messages[locale] = messages
  },
  SET_MESSAGE(state, { locale, key, value }) {
    if (
      state.messages[locale] === undefined ||
      state.messages[locale] === null
    ) {
      state.messages[locale] = {}
    }
    state.messages[locale][key] = value
  }
}
